import React from "react";
import { Link } from "react-router-dom";
import { MessageCircle, Plus, Check } from "lucide-react";
import { useEnquiry } from "@/context/EnquiryContext";
import { useSettings } from "@/context/SettingsContext";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

export default function ProductCard({ product }) {
  const { add, items } = useEnquiry();
  const s = useSettings();
  const inList = items.some(i => i.product_id === product.id);
  const wa = s.whatsapp_primary || "9513951318";
  const waMsg = encodeURIComponent(`Hello REXTECH IT SOLUTION, I am interested in ${product.name}. Please share availability and wholesale price.`);
  return (
    <div className="group bg-white border border-[#E2E8F0] rounded-md overflow-hidden flex flex-col hover:shadow-lg transition-shadow" data-testid={`product-card-${product.id}`}>
      <Link to={`/products/${product.slug}`} className="block bg-slate-50 aspect-square overflow-hidden">
        <img src={product.images?.[0] || "https://images.unsplash.com/photo-1518770660439-4636190af475?w=600&q=80"}
             alt={product.name} loading="lazy"
             className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"/>
      </Link>
      <div className="p-4 flex flex-col gap-2 flex-1">
        <div className="flex flex-wrap gap-1">
          {product.featured && <Badge className="bg-[#EA580C] hover:bg-[#EA580C] text-white text-[10px]">Featured</Badge>}
          {product.new_arrival && <Badge className="bg-[#1E3A8A] hover:bg-[#1E3A8A] text-white text-[10px]">New</Badge>}
          {product.offer && <Badge className="bg-emerald-600 hover:bg-emerald-600 text-white text-[10px]">Offer</Badge>}
          <Badge variant="outline" className="text-[10px] border-[#E2E8F0]">{product.condition}</Badge>
        </div>
        <Link to={`/products/${product.slug}`} className="font-heading font-semibold text-slate-900 line-clamp-2 hover:text-[#EA580C]">{product.name}</Link>
        <div className="text-xs text-slate-500">SKU: {product.sku}</div>
        <div className="text-xs text-slate-600">
          {Object.entries(product.specifications || {}).slice(0, 2).map(([k, v]) => (
            <div key={k}><span className="text-slate-400">{k}:</span> {v}</div>
          ))}
        </div>
        <div className="mt-auto pt-2 flex flex-col gap-2">
          <div className="text-sm font-semibold text-[#EA580C]">Request Wholesale Price</div>
          <div className="flex gap-2">
            <Button size="sm" className="btn-orange flex-1"
              onClick={() => { add(product, 1); toast.success(`${product.name} added to enquiry`); }}
              data-testid={`add-enquiry-${product.id}`}>
              {inList ? <Check className="w-4 h-4 mr-1"/> : <Plus className="w-4 h-4 mr-1"/>}
              {inList ? "Added" : "Add to Enquiry"}
            </Button>
            <a href={`https://wa.me/91${wa}?text=${waMsg}`} target="_blank" rel="noreferrer">
              <Button size="sm" variant="outline" className="border-[#25D366] text-[#25D366] hover:bg-[#25D366] hover:text-white">
                <MessageCircle className="w-4 h-4"/>
              </Button>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
